export const formatRuCount = (
    count: number,
    one: string,
    few: string,
    many: string,
): string => {
    const lastTwoDigits = count % 100
    const lastDigit = count % 10

    if(lastTwoDigits >= 11 && lastTwoDigits <= 14) return `${count} ${many}`
    if(lastDigit === 1) return `${count} ${one}`
    if(lastDigit >= 2 && lastDigit <= 4) return `${count} ${few}`

    return `${count} ${many}`
}

export const formatLessonsCount = (count: number): string => {
    return formatRuCount(count, 'занятие', 'занятия', 'занятий')
}
